<div #rulerLabels class="absolute left-0 z-10"></div>
<div #container class="perio-quadrant-container" [class.left-side]="isLeftSide()"></div>
